(function ($) {
 "use strict";
 jQuery(document).ready(function(){
   
   /*category left menu*/
    $('.category-heading').on('click', function(){
        $('.category-menu-list').slideToggle(300);
    });
   jQuery( ".home_menu ul li ul" ).parent('li').append('<i class="fa fa-angle-down"></i>');
/*----------------------------
 jQuery MeanMenu
------------------------------ */
	jQuery('nav#dropdown').meanmenu();	 

/*----------------------------
 owl active
------------------------------ */  
  
 	$(".features").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 3,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
    
/*----------------------------
owl active index-3  start
------------------------------ */  
    $(".futurum").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 1,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,1],
        itemsDesktopSmall : [979,2],
        itemsMobile : [767,1]
    });
    $(".item_all_another").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 3,   
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,4],
        itemsMobile : [767,2]
    });
    /*----------------------------
owl active index-3 start
------------------------------ */ 
   
/*----------------------------
owl active shop-details  start
------------------------------ */  
    $(".more-views").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 3,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
    $(".content_all").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 1,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,1],
        itemsDesktopSmall : [979,1],
        itemsMobile : [767,1]
    });
    $(".UpSell").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 5,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
  
/*----------------------------
owl active shop-details  start
------------------------------ */  
    $(".more-views").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 3,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
    $(".content_all").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 1,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
    $(".UpSell").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 5,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
   $(".what-client-say").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 1,
        pagination:true,
        navigation:false,
        navigationText:false,
        animateOut:'fade',
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,1]
    });
/*----------------------------
blog-slider active
------------------------------ */ 
    $(".b-slide-all").owlCarousel({
        autoPlay: false, 
        slideSpeed:2000,
        items : 1,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,1],
        itemsDesktopSmall : [979,1],
        itemsMobile : [767,1]
    });
      $(".product-single_thumbnails").owlCarousel({
       autoPlay: false, 
        slideSpeed:2000,
        items : 3,
        pagination:false,
        navigation:true,
        navigationText:["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [979,3],
        itemsMobile : [767,3]
   });


    
  
  
  
  });
   
})(jQuery); 